module.exports = __webpack_public_path__ + "static/media/orange_un.ccef6bda.png";